export default __webpack_public_path__ + "static/media/fr-asia-12.39801787.jpg";